export default function CableSchemasPanel() {
  return (
    <div className="mt-2 space-y-3 text-xs sm:text-sm">
      <p className="text-gray-300">
        Tu feuillettes un classeur rempli de schémas techniques. Plusieurs
        pages ont été surlignées en fluo : visiblement, c’est la version à jour
        et documentée que l’équipe doit suivre.
      </p>

      <p className="mt-2 text-indigo-300">
        Note : il faut que tous les branchements soient corrects pour que ça
        marche… et pour éviter les interventions d’urgence en pleine nuit.
        Les procédures recommandent de ne plus “bricoler” les câbles au hasard.
      </p>

      <div className="rounded-lg border border-white/10 bg-black/40 p-3 font-mono">
        <p className="font-semibold text-indigo-200 mb-1">
          Serveur 1 — SERVEUR APPLICATION
        </p>
        <p>Ports actifs : A, C</p>
        <p>Remarque : B doit rester hors-ligne.</p>
      </div>

      <div className="rounded-lg border border-white/10 bg-black/40 p-3 font-mono">
        <p className="font-semibold text-indigo-200 mb-1">
          Serveur 2 — SERVEUR BASE DE DONNÉES
        </p>
        <p>Ports actifs : B, C</p>
      </div>

      <div className="rounded-lg border border-white/10 bg-black/40 p-3 font-mono">
        <p className="font-semibold text-indigo-200 mb-1">
          Rack principal — DISTRIB RÉSEAU
        </p>
        <p>Ports actifs : B, C, H, I</p>
      </div>

      <div className="rounded-lg border border-white/10 bg-black/40 p-3 font-mono">
        <p className="font-semibold text-indigo-200 mb-1">
          Bloc auxiliaire — Sauvegardes
        </p>
        <p>Ports actifs : A, B</p>
        <p className="text-amber-300">
          Note griffonnée : NE SURTOUT PAS DÉBRANCHER — c’est un des points clés
          du plan de continuité de service.
        </p>
      </div>
    </div>
  );
}